import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type {
  StaffNotificationRecipientDto,
  StaffNotificationSettingsResponseDto,
  StaffNotificationTestResponseDto,
  UpdateStaffNotificationSettingsDto,
} from '@lunary/api-client'
import { ApiError, api } from '../../shared/api/client'

export const NOTIFICATIONS_KEY = ['admin', 'notification-settings'] as const

export function notificationsErrorText(e: unknown): string {
  if (e instanceof ApiError) return e.message
  return 'Не получилось. Проверьте соединение и повторите'
}

export function useNotificationSettings() {
  return useQuery({
    queryKey: NOTIFICATIONS_KEY,
    queryFn: () => api.get<StaffNotificationSettingsResponseDto>('/admin/notification-settings'),
    retry: false,
  })
}

export function useSaveNotificationSettings() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: { telegramId: string; body: UpdateStaffNotificationSettingsDto }) =>
      api.put<StaffNotificationRecipientDto>(`/admin/notification-settings/${encodeURIComponent(input.telegramId)}`, input.body),
    onSuccess: (saved) => {
      qc.setQueryData<StaffNotificationSettingsResponseDto>(NOTIFICATIONS_KEY, (current) =>
        current ? { ...current, recipients: current.recipients.map((r) => (r.telegram_id === saved.telegram_id ? saved : r)) } : current,
      )
    },
  })
}

export function useTestNotification() {
  return useMutation({
    mutationFn: (telegramId: string) =>
      api.post<StaffNotificationTestResponseDto>(`/admin/notification-settings/${encodeURIComponent(telegramId)}/test`),
  })
}
